<template>
  <div class="container">
    <div class="outer-container">
      <h2>
        How will It Works?
      </h2>
      <br />
      <h4>
     Upskill covers the cost of the CSS course for you. There’s no down payment. If you’re hired by Chaldal after the course ends, you’ll make a one-time payment of BDT 15000 to Upskill from your first month’s salary at Chaldal.
      </h4>
      <div class="grid">
        <div>
          <h3>
            GET REAL WORK <br />
            EXPERIENCE
          </h3>
          <p>
            Master the skills most required for full stack engineers by
            completing this 1.5 months’ practical and project-based CSS course.
          </p>
        </div>

        <div>
          <h3>
           NO FEES UNLESS <br />
            YOU'RE HIRED
          </h3>
          <p>
           You’ll only pay fees to Upskill if you are hired by Chaldal. You’ll make a one-time payment, BDT 15,000 of your first month’s salary.
          </p>
        </div>
        <div>
          <h3>
            GET CONNECTED <br /> <br>

          </h3>
          <p>
          Successfully complete the CSS course and assessments to be interviewed by Chaldal.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.outer-container {
  padding: 0 25px;
  padding-top: 100px;
  padding-bottom: 90px;
}
.outer-container h2 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
  color: black;
  padding-bottom: 15px;
  border-bottom: 1px solid #304f64;
}
.outer-container h4 {
  font-family: "Poppins";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 32px;
  color: #304f64;
  padding-top: 25px;
  padding-bottom: 50px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}
.grid h3 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  color: #072ac8;
  padding-bottom: 48px;
}
.grid p {
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304f64;
  padding-right: 25px;
}
@media only screen and (min-width: 601px) and (max-width: 1100px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding-left: 0;
    padding-right: 0;
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .outer-container {
    padding: 0 20px;
    padding-top: 50px;
    padding-bottom: 45px;
  }
  .outer-container h2 {
    text-transform: uppercase;

    font-size: 16px;

    letter-spacing: 6.4px;
    line-height: 24px;
    padding-bottom: 30px;
  }
  .outer-container h4 {
    font-family: "Poppins";
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 24px;
    color: #304f64;
    padding-top: 0px;
    padding-bottom: 10px;
  }
  .grid h3 {
    padding-bottom: 20px;
    padding-top: 30px;
    padding-right: 0;
  }
}
@media only screen and (min-width: 1300px) {
  .container {
    max-width: 1350px !important;
  }
}
</style>
